import {
    PropsWithChildren,
    createContext,
    useContext,
    useEffect,
    useState,
} from 'react';

interface ReviewCarouselProviderProps {
    reviews?: any; // TODO: Define type
    isLoading?: boolean;
}

type ReviewCarouselContextType = {
    reviews: any;
    setReviews: (reviewList: any) => void;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
};

const ReviewCarouselContext = createContext<
    ReviewCarouselContextType | undefined
>(undefined);
export const ReviewCarouselProvider = ({
    reviews: initialReviews,
    isLoading: initialIsLoading,
    children,
}: PropsWithChildren<ReviewCarouselProviderProps>): JSX.Element => {
    const [reviews, setReviews] = useState<any>(initialReviews ?? []);
    const [isLoading, setIsLoading] = useState<boolean>(
        initialIsLoading ?? false
    );

    useEffect(() => {
        if (initialReviews) {
            setReviews(initialReviews);
        }
    }, [initialReviews]);

    return (
        <ReviewCarouselContext.Provider
            value={{
                reviews,
                setReviews,
                isLoading,
                setIsLoading,
            }}
        >
            {children}
        </ReviewCarouselContext.Provider>
    );
};

export const useReviewCarousel = () => {
    const context = useContext(ReviewCarouselContext);
    if (context === undefined) {
        throw new Error(
            'useReviewCarousel must be used within a ReviewCarouselProvider'
        );
    }
    return context;
};
